import { render, staticRenderFns } from "./twoPageHeader.vue?vue&type=template&id=76614ed9&scoped=true&"
import script from "./twoPageHeader.vue?vue&type=script&lang=js&"
export * from "./twoPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./twoPageHeader.vue?vue&type=style&index=0&id=76614ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76614ed9",
  null
  
)

export default component.exports